<template>
  <v-app id="required-resources-list" class="required-resources-list">
    <!--begin::Dashboard-->
    <div class="card card-custom card-stretch h-auto">
      <!--begin::Header-->
      <div class="card-header border-0 py-5 align-items-center">
        <h3 class="card-title align-items-start flex-column m-0 py-3">
          <span class="card-label font-weight-bolder text-dark">
            Requests need Referral
          </span>
          <span class="text-muted mt-2 font-weight-bold font-size-sm">
            Required resources tagged #request_referral_needed in ClickUp
          </span>
        </h3>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body pt-0 pb-3">
        <div class="tab-content">
          <!--begin::Table-->
          <div
            v-if="resources && resources.length"
            class="table-responsive mb-0"
          >
            <table
              class="table table-head-custom table-vertical-center table-striped text-left table-head-bg table-borderless"
            >
              <thead>
                <tr>
                  <th style="min-width: 180px">
                    <span>Resource</span>
                  </th>
                  <th style="min-width: 130px">
                    <span>Role</span>
                  </th>
                  <th style="min-width: 130px">
                    <span>Status</span>
                  </th>
                  <th style="min-width: 160px">
                    <span>Client</span>
                  </th>
                  <th style="min-width: 130px">
                    <span>Squad</span>
                  </th>
                  <th style="min-width: 150px">
                    <span>Requested By</span>
                  </th>
                  <th style="min-width: 150px">
                    <span>Requested At</span>
                  </th>
                  <th style="min-width: 80px" class="text-center">
                    <span>ClickUp</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="resource in resources" :key="resource.id">
                  <td class="font-weight-bolder">
                    <span>{{ resource.resource_name }}</span>
                  </td>
                  <td class="font-weight-bolder">
                    <span>{{ resource.role || "-" }}</span>
                  </td>
                  <td class="font-weight-bolder">
                    <span>{{
                      (resource.status && resource.status.name) || "-"
                    }}</span>
                  </td>
                  <td class="font-weight-bolder">
                    <a
                      v-if="resource.client_project"
                      :href="
                        `/dashboard/client/${resource.client_project.client.id}/project/${resource.client_project.id}`
                      "
                      target="_blank"
                      rel="noopener"
                    >
                      {{ resource.client_project.client.name }}
                    </a>
                    <span v-else>-</span>
                  </td>
                  <td class="font-weight-bolder">
                    <span>
                      {{
                        (resource.client_project &&
                          resource.client_project.name) ||
                          "-"
                      }}
                    </span>
                  </td>
                  <td class="font-weight-bolder">
                    <span>{{ resource.requested_by || "-" }}</span>
                  </td>
                  <td class="font-weight-bolder">
                    <span>{{
                      formatDate(resource.referral_requested_at)
                    }}</span>
                  </td>
                  <td class="text-center">
                    <a
                      v-if="resource.clickup_task_url"
                      :href="resource.clickup_task_url"
                      target="_blank"
                      rel="noopener"
                      v-b-tooltip.hover="resource.resource_name"
                    >
                      <img
                        style="height: 2.5rem; width: 2.5rem"
                        src="@/assets/images/clickup.png"
                        alt="clickup"
                      />
                    </a>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h5
            class="my-5 text-muted text-center"
            v-else-if="resources && resources.length === 0"
          >
            No Results Found
          </h5>
          <div class="pagination-container">
            <p
              v-if="resources && resources.length > 0"
              class="pagination-container__desc"
            >
              {{
                $t("showing_results", {
                  length: resources.length,
                  total: resourcesMeta.total
                })
              }}
            </p>
            <b-pagination
              v-if="resourcesMeta && resourcesMeta.last_page > 1"
              v-model="page"
              :total-rows="resourcesMeta.total"
              :per-page="perPage"
              align="center"
              last-number
              first-number
            >
            </b-pagination>
          </div>
          <!--end::Table-->
        </div>
      </div>
      <!--end::Body-->
    </div>
    <!--end::Dashboard-->
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import dayjs from "dayjs";

export default {
  name: "RequiredResourcesList",
  data() {
    return {
      page: 1,
      perPage: 15
    };
  },
  computed: {
    ...mapGetters({
      resources: "requiredResources/getRequiredResourcesData",
      resourcesMeta: "requiredResources/getRequiredResourcesMeta"
    })
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "/dashboard" },
      { title: "Requests need Referral" }
    ]);
    this.handleGettingResourcesData();
  },
  watch: {
    page() {
      this.handleGettingResourcesData();
    }
  },
  methods: {
    ...mapActions({
      getRequiredResourcesData: "requiredResources/getRequiredResourcesData"
    }),
    async handleGettingResourcesData() {
      await this.getRequiredResourcesData({
        page: this.page,
        perPage: this.perPage
      });
    },
    formatDate(date) {
      return date ? dayjs(date).format("DD/MM/YYYY hh:mm a") : "-";
    }
  }
};
</script>

<style lang="scss" scoped>
.table.table-vertical-center {
  tr {
    &:hover {
      background: #f8f9fa;
    }
  }
  th {
    color: #3f4254 !important;
  }
  td {
    padding-top: 16px;
    vertical-align: top;
  }
}
</style>
